export default __webpack_public_path__ + "static/media/logo_scroll.e42207e4.svg";